module.exports = __webpack_public_path__ + "static/media/orange_animal_reptiles.7845c869.webp";